/* Mats · Producto destacado — animación de entrada + favoritos */
(function () {
  if (window.MatsProductFeature) return;

  /* ---------- Animación de entrada ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = !reduce && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' })
    : null;

  function initReveal(scope) {
    (scope || document).querySelectorAll('.mats-pf[data-mpf-reveal]').forEach(function (el) {
      if (el.dataset.mpfInit) return;
      el.dataset.mpfInit = '1';
      if (!io) return;
      el.classList.add('is-armed');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { io.observe(el); });
      });
    });
  }

  /* ---------- Favoritos ----------
     Usa window.MatsWishlist si existe (toggle / has); si no, solo cambia el estado
     visual y emite el evento "mats:wishlist:toggle" para que otro script lo recoja. */
  function wishlistApi() {
    var W = window.MatsWishlist;
    return W && typeof W === 'object' ? W : null;
  }

  function syncWish(scope) {
    var W = wishlistApi();
    if (!W || typeof W.has !== 'function') return;
    (scope || document).querySelectorAll('[data-mats-pf-wish]').forEach(function (btn) {
      try {
        var on = !!W.has(btn.dataset.productHandle, btn.dataset.productId);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      } catch (e) { /* noop */ }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mats-pf-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var detail = {
      handle: btn.dataset.productHandle,
      id: btn.dataset.productId,
      url: btn.dataset.productUrl
    };
    var next = btn.getAttribute('aria-pressed') !== 'true';
    var W = wishlistApi();

    if (W && typeof W.toggle === 'function') {
      try {
        var result = W.toggle(detail.handle, detail);
        if (typeof result === 'boolean') next = result;
      } catch (err) { /* noop */ }
    }

    btn.setAttribute('aria-pressed', next ? 'true' : 'false');
    detail.active = next;
    document.dispatchEvent(new CustomEvent('mats:wishlist:toggle', { detail: detail }));
  });

  // Mantener todos los botones del mismo producto sincronizados
  document.addEventListener('mats:wishlist:toggle', function (e) {
    if (!e.detail || !e.detail.handle) return;
    document.querySelectorAll('[data-mats-pf-wish][data-product-handle="' + e.detail.handle + '"]').forEach(function (b) {
      b.setAttribute('aria-pressed', e.detail.active ? 'true' : 'false');
    });
  });

  function init(scope) {
    initReveal(scope);
    syncWish(scope);
  }

  window.MatsProductFeature = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var pf = e.target.closest && e.target.closest('.mats-pf');
    if (pf) pf.classList.add('is-visible');
  });
})();
